<template>
  <input class="row-nice__input" type="time" v-model="value" @keyup="updateValue" @change="updateValue"/>
</template>

<script>
import InputBase from "./InputBase";

export default {
  name: "InputTime",
  extends: InputBase,
  props: {
    name: {},
    value: {}
  },
  data: () => ({}),
  methods: {
    val() {
      return this.value;
    },
    updateValue() {
      this.$emit('updateValue', this.name, this.value);
    }
  }
}
</script>